import Head from 'next/head';
import React, { useEffect } from 'react';
import { AuthProvider } from '../contexts/AuthContext';
import '../styles/globals.css';
import { ThemeProvider } from 'next-themes'
import { useRouter } from 'next/router';
import { AmplitudeProvider } from '../contexts/AmplitudeContext';

function MyApp({ Component, pageProps }) {

  return (
    <AuthProvider>
      <AmplitudeProvider>
        <ThemeProvider attribute="class">
          <Component {...pageProps} />
        </ThemeProvider>
      </AmplitudeProvider>
    </AuthProvider>
  );
}

export default MyApp
